module.exports = __webpack_public_path__ + "static/quiz_stage_8_bg-e8c522cd917114685a43c0d8dfb1d70d.svg";